export type Standort = { name: string; lat: number; lng: number };

export const standorte: Standort[] = [
  { name: 'Gütersloh', lat: 51.9066, lng: 8.3785 },
  { name: 'Bielefeld', lat: 52.0302, lng: 8.5325 },
  { name: 'Bielefeld-Jöllenbeck', lat: 52.0839, lng: 8.4936 },
  { name: 'Rheda-Wiedenbrück', lat: 51.8503, lng: 8.2997 },
  { name: 'Verl', lat: 51.8831, lng: 8.5152 },
  { name: 'Halle (Westf.)', lat: 52.0606, lng: 8.3614 },
  { name: 'Steinhagen', lat: 52.0008, lng: 8.3997 },
  { name: 'Harsewinkel', lat: 51.9686, lng: 8.2278 },
  { name: 'Herzebrock-Clarholz', lat: 51.8872, lng: 8.2320 },
  { name: 'Rietberg', lat: 51.8090, lng: 8.4283 },
  { name: 'Versmold', lat: 52.0417, lng: 8.1508 },
  { name: 'Werther', lat: 52.0806, lng: 8.4128 },
  { name: 'Schloß Holte-Stukenbrock', lat: 51.9008, lng: 8.6197 },
  { name: 'Enger', lat: 52.1417, lng: 8.5697 },
  { name: 'Spenge', lat: 52.1394, lng: 8.4842 },
  { name: 'Herford', lat: 52.1157, lng: 8.6745 },
  { name: 'Hiddenhausen', lat: 52.1650, lng: 8.6200 },
  { name: 'Bünde', lat: 52.1989, lng: 8.5850 },
  { name: 'Kirchlengern', lat: 52.2000, lng: 8.6350 },
];

// Weiter entfernte Gebiete – auf Anfrage.
export const zusatzgebiete: Standort[] = [
  { name: 'Hamm', lat: 51.6739, lng: 7.8150 },
  { name: 'Schwäbisch Hall', lat: 49.1120, lng: 9.7377 },
];
